<script setup lang="ts">
    const { t } = useLocales();

    interface ProductOptionsProps {
        config?: IConfigurable;
        isPDP?: boolean;
        redCharity?: boolean;
        changeHoverColorOption?: (option: string) => void;
    }

    const props = defineProps<ProductOptionsProps>();

    const nameValue = ref<string>('');

    watch(nameValue, () => {
        props.config?.setCustomField('Name', nameValue.value);
    });

    const dropDownValue = ref<Array<string>>([]);
    watch(dropDownValue, () => {
        props.config?.setCustomField(t('bikeOptions.original.key'), dropDownValue.value);
    });

    const originalSelection = computed(() => {
        const options = [];
        for (let i = 0; i < 7; i += 1) {
            const translation = t(`bikeOptions.original.option${i}`);
            options.push({ value: translation, label: translation });
        }
        return options;
    });

    const nameError = computed(() => {
        if (props.config?.nameError.value) {
            return t(props.config.nameError.value);
        }
        return undefined;
    });
</script>
<template>
    <div
        v-if="config?.hasRenderOptions"
        class="org-product-options">
        <template v-for="option in config.options">
            <template v-if="option.type.includes('Color')">
                <lazy-mol-product-option-color
                    :key="option.type"
                    :option="option"
                    :hide-heading="config.options.length === 1"
                    :redCharity="redCharity"
                    :change-hover-color-option="changeHoverColorOption" />
            </template>
            <template v-else>
                <lazy-mol-product-option-select
                    v-if="option.canRender"
                    :key="option.type"
                    class="mt-8"
                    :option="option"
                    :config="config"
                    :isPDP="isPDP" />
            </template>
        </template>
        <template v-if="config.hasNameField">
            <lazy-mol-form-text
                v-model:text-value="nameValue"
                for-id="name-field"
                :label="$t('product.nameField')"
                :error="nameError"
                :required="true" />
        </template>
        <template v-if="config.hasOriginalSelection">
            <lazy-mol-form-select
                v-model:dropdown-value="dropDownValue"
                :label="$t('bikeOptions.original.label')"
                :options="originalSelection"
                :multiple="true"
                :required="true" />
        </template>
        <!-- WILL BE ENABLED IN ECOMM-833 -->
        <!-- <template v-if="config.isGiftCard">
            <lazy-mol-product-option-gift-card-color :config="config" />
        </template> -->
    </div>
</template>
